import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as echarts from "echarts";
import api from "api-client";
import utils from "./utils/utils";
import dateUtils from "@/utils/dateUtils";
import { getValidate } from "@/utils/validate";
import { getMsg } from "@/utils/message";
import VueSignaturePad from "vue-signature-pad";
import VDate from "@/components/VDate";
import VTime from "@/components/VTime";
import VDateMonth from "@/components/VDateMonth";

//vue-signature-pad
Vue.use(VueSignaturePad);

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm, info) => {
  alert("サーバエラーが発生しました。");
  console.error("errorHandler err:", err);
  console.error("errorHandler vm:", vm);
  console.error("errorHandler info:", info);
};
//
Vue.prototype.$dateUtils = dateUtils;
//echarts
Vue.prototype.$echarts = echarts;
//axios
Vue.prototype.$api = api.apis;
//utils
Vue.prototype.$utils = utils;
Vue.prototype.$getValidate = getValidate;
Vue.prototype.$getMsg = getMsg;
//v-date
Vue.component("VDate", VDate);
//v-time
Vue.component("VTime", VTime);
//v-date-month
Vue.component("VDateMonth", VDateMonth);
//dateUtils
Date.prototype.format = dateUtils.dateFormat;
Date.prototype.getFirstDayOfMonth = dateUtils.getFirstDayOfMonth;
Date.prototype.getLastDayOfMonth = dateUtils.getLastDayOfMonth;
Date.prototype.setMonthByStep = dateUtils.setMonthByStep;
Date.prototype.setDateByStep = dateUtils.setDateByStep;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
